"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tstroke: ", ";\n\tstroke-dasharray: 1, 200;\n\tstroke-dashoffset: 0;\n\tanimation: ", " 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n\tstroke-linecap: round;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tanimation: ", " 2s linear infinite;\n\ttransform-origin: center center;\n\twidth: ", ";\n\theight: ", ";\n\tvertical-align: middle;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Rotate = (0, _styledComponents.keyframes)(_templateObject());
var Dash = (0, _styledComponents.keyframes)(_templateObject2());

var Circular = _styledComponents.default.svg(_templateObject3(), Rotate, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

Circular.displayName = 'Circular';

var Circle = _styledComponents.default.circle(_templateObject4(), function (props) {
  return props.standalone ? _colors.default.secondary : 'currentColor';
}, Dash);

Circle.displayName = 'Circle';

var InlineLoader = function InlineLoader(_ref) {
  var isLoading = _ref.isLoading,
      standalone = _ref.standalone,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, ["isLoading", "standalone", "size"]);

  if (!isLoading) {
    return null;
  }

  return _react.default.createElement(Circular, _extends({
    className: "circular",
    viewBox: "24 24 48 48",
    size: size
  }, rest), _react.default.createElement(Circle, {
    standalone: standalone,
    className: "loading-path",
    cx: "48",
    cy: "48",
    r: "20",
    fill: "none",
    strokeWidth: "6",
    strokeMiterlimit: "10"
  }));
};

InlineLoader.displayName = 'InlineLoader';
InlineLoader.propTypes = {
  isLoading: _propTypes.bool.isRequired,
  standalone: _propTypes.bool,
  size: _propTypes.string
};
InlineLoader.defaultProps = {
  standalone: false,
  size: '16px'
};
var _default = InlineLoader;
exports.default = _default;